import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from './ProductCard';
import './CategoryCard.css';

const CategoryCard = ({ categoria, icon, produtos }) => {
  if (!produtos || produtos.length === 0) return null;

  return (
    <div className="category-card">
      <div className="category-header">
        <div className="category-title">
          <span className="category-icon">{icon}</span>
          <h3>{categoria}</h3>
        </div>
        <Link to={`/produtos?categoria=${encodeURIComponent(categoria)}`} className="ver-mais-link">
          Ver mais →
        </Link>
      </div>
      <div className="category-products">
        {produtos.map(produto => (
          <ProductCard key={produto.id} produto={produto} />
        ))}
      </div>
    </div>
  );
};

export default CategoryCard;

